import styled from 'styled-components';
import { Select } from '@/ui';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledHeaderWrap = styled.div`
  padding: 6rem;
  padding-bottom: 2rem;
  gap: 2rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: ${COLORS.LIGHTEST_GRAY};
`;

export const StyledSelect = styled(Select)<{ $isActive: boolean }>`
  &&& {
    height: 2.85rem;
    .ant-select-selection-item {
      color: ${({ $isActive }) => ($isActive ? COLORS.GREEN : COLORS.RED)} !important;
    }
  }
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('30', '30', 'BOLD')};
  color: ${COLORS.BLACK};
  text-align: left;
`;
